// if you update it, please update variables.scss as well
export const AUTO_COLLAPSE_SIDE_MENU_BREAKPOINT = '(max-width: 93.75rem)'; // 1500px
export const BUTTONS_AS_ICONS_BREAKPOINT = '(max-width: 109.375rem)'; // 1750px
